const Categories = () => (
  <div>
    <h1>Under construction</h1>
  </div>
);

export default Categories;
